export default __webpack_public_path__ + "img/app-page/screen3_us.491ba1546ef28244b59d4b716755657a.png";